import { WifiOff, Loader2, CheckCircle2, RefreshCw } from 'lucide-react';
import { Header } from '@/components/Header';
import { Button } from '@/components/ui/button';
import { useISPStatus } from './hooks/useISPStatus';
import { ISPGroupCard } from './components/ISPGroupCard';

export function ISPStatusPage() {
  const { data, isLoading, error, refetch, isRefetching } = useISPStatus();

  return (
    <div className="flex flex-col min-h-full">
      <Header
        title="Статус интернета"
        subtitle={data ? `${data.totalDown} проблем` : undefined}
        showBack
        rightContent={
          <Button
            variant="ghost"
            size="icon"
            onClick={() => refetch()}
            disabled={isRefetching}
          >
            <RefreshCw className={`h-5 w-5 ${isRefetching ? 'animate-spin' : ''}`} />
          </Button>
        }
      />

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <WifiOff className="h-12 w-12 text-destructive mx-auto mb-4" />
            <p className="text-destructive font-medium">Ошибка загрузки</p>
            <Button
              variant="outline"
              size="sm"
              onClick={() => refetch()}
              className="mt-4"
            >
              Повторить
            </Button>
          </div>
        ) : !data || data.totalDown === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
            <CheckCircle2 className="h-16 w-16 text-green-500 mb-4" />
            <p className="text-lg font-medium text-foreground">Все работает!</p>
            <p className="text-sm">Проблем с интернетом не обнаружено</p>
          </div>
        ) : (
          <>
            {/* Summary stats */}
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20">
                <div className="text-2xl font-bold text-destructive">{data.totalDown}</div>
                <div className="text-xs text-muted-foreground">Всего проблем</div>
              </div>
              <div className="p-3 rounded-lg bg-muted">
                <div className="text-2xl font-bold">{Object.keys(data.groupedByISP).length}</div>
                <div className="text-xs text-muted-foreground">Провайдеров</div>
              </div>
            </div>

            {/* Groups by ISP */}
            {Object.entries(data.groupedByISP).map(([isp, clients]) => (
              <ISPGroupCard key={isp} isp={isp} clients={clients} />
            ))}
          </>
        )}
      </div>
    </div>
  );
}
